import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import toast from "react-hot-toast";
import {
  useGetDesignationQuery,
  useRenameDesignationMutation,
  useAssignDesignationPermissionMutation,
  useRemoveDesignationPermissionMutation,
} from "../designationsApi";
import { useGetPermissionsQuery } from "../../admin/adminApi";
import PermissionChecklist from "../../../components/common/PermissionChecklist";

const DesignationEditModal = ({ designationId, onClose }) => {
  const show = Boolean(designationId);
  const { data, isFetching } = useGetDesignationQuery(designationId, {
    skip: !designationId,
  });
  const { data: allPermissions = [] } = useGetPermissionsQuery();
  const [renameDesignation, { isLoading: isRenaming }] =
    useRenameDesignationMutation();
  const [assignPermission] = useAssignDesignationPermissionMutation();
  const [removePermission] = useRemoveDesignationPermissionMutation();
  const [designationName, setDesignationName] = useState("");

  useEffect(() => {
    setDesignationName(data?.designation?.designationName || "");
  }, [data]);

  const handleSaveName = async () => {
    if (
      !designationName.trim() ||
      designationName === data?.designation?.designationName
    )
      return;
    try {
      await renameDesignation({
        designationId,
        designationName: designationName.trim(),
      }).unwrap();
      toast.success("Designation renamed");
    } catch (error) {
      toast.error(error?.message || "Could not rename designation");
    }
  };

  const handleTogglePermission = async (permissionId, checked) => {
    try {
      if (checked) {
        await assignPermission({ designationId, permissionId }).unwrap();
      } else {
        await removePermission({ designationId, permissionId }).unwrap();
      }
    } catch (error) {
      toast.error(error?.message || "Could not update permission");
    }
  };

  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {data?.designation?.designationCode
            ? `Edit Designation · ${data.designation.designationCode}`
            : "Edit Designation"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isFetching && !data ? (
          <p>Loading...</p>
        ) : (
          <>
            <div className="mb-4">
              <label className="form-label">Designation Name</label>
              <div className="d-flex gap-2">
                <input
                  type="text"
                  className="form-control"
                  value={designationName}
                  onChange={(e) => setDesignationName(e.target.value)}
                  onBlur={handleSaveName}
                />
                <Button
                  variant="outline-primary"
                  onClick={handleSaveName}
                  disabled={
                    isRenaming ||
                    designationName === data?.designation?.designationName
                  }
                >
                  Save
                </Button>
              </div>
            </div>

            <h6 className="mb-3">Default Permissions</h6>
            <PermissionChecklist
              permissions={allPermissions}
              selectedIds={(data?.permissions || []).map(
                (p) => p.permissionId
              )}
              onToggle={handleTogglePermission}
            />
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DesignationEditModal;
